// Built-in sticker/GIF library using Twemoji CDN (jsDelivr, reliable, hotlink-friendly).
// Users can insert these into posts via WYSIWYG editor picker.
const TW = (code) =>
  `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/${code}.png`;

export const STICKERS = [
  { id: "s1", label: "دل", url: TW("2764") },
  { id: "s2", label: "ہنسی", url: TW("1f602") },
  { id: "s3", label: "پسند", url: TW("1f44d") },
  { id: "s4", label: "تالی", url: TW("1f44f") },
  { id: "s5", label: "آگ", url: TW("1f525") },
  { id: "s6", label: "سلام", url: TW("1f64f") },
  { id: "s7", label: "سوچ", url: TW("1f914") },
  { id: "s8", label: "حیرت", url: TW("1f62e") },
  { id: "s9", label: "غم", url: TW("1f62d") },
  { id: "s10", label: "پرچم", url: TW("1f1f5-1f1f0") },
  { id: "s11", label: "چاند", url: TW("262a") },
  { id: "s12", label: "کرکٹ", url: TW("1f3cf") },
  { id: "s13", label: "کتاب", url: TW("1f4d6") },
  { id: "s14", label: "چائے", url: TW("1f375") },
  { id: "s15", label: "کھانا", url: TW("1f372") },
  { id: "s16", label: "دعا", url: TW("1f54c") },
  { id: "s17", label: "مسکراہٹ", url: TW("1f60a") },
  { id: "s18", label: "آنکھ مارنا", url: TW("1f609") },
  { id: "s19", label: "حیران", url: TW("1f632") },
  { id: "s20", label: "زبردست", url: TW("1f44c") },
];

export const GIFS = [
  { id: "g1", label: "خوش آمدید", url: "https://media.tenor.com/JVQ4mIrOEqIAAAAi/welcome.gif" },
  { id: "g2", label: "شکریہ", url: "https://media.tenor.com/rke1s3Q_zY4AAAAi/cat-thanks.gif" },
  { id: "g3", label: "زبردست", url: "https://media.tenor.com/9x-D2Bt9lC0AAAAi/thumbs-up.gif" },
  { id: "g4", label: "ہنسی", url: "https://media.tenor.com/HB5nJEZFQqEAAAAi/lol.gif" },
  { id: "g5", label: "متفق", url: "https://media.tenor.com/5jr17XYnQ4gAAAAi/agree-agreed.gif" },
  { id: "g6", label: "دلچسپ", url: "https://media.tenor.com/BQaIovcQ1DIAAAAi/interesting-hmm.gif" },
  { id: "g7", label: "افسوس", url: "https://media.tenor.com/6NNaYCzsJmMAAAAi/sad-cat.gif" },
  { id: "g8", label: "حیران", url: "https://media.tenor.com/g9zwQZ_ycEIAAAAi/shocked-cat.gif" },
];
